import CardListPageTemplate from '../components/CardListPageTemplate';

const Index = () => {
  return <CardListPageTemplate selectedCategorySlug={null} />;
};

export default Index;